/* tslint:disable */
/* eslint-disable */
export enum AssetCashInvestmentRequestCashInvestmentType {
  None = 'None',
  Savings = 'Savings',
  Investment = 'Investment',
  Superannuation = 'Superannuation'
}
